import { TAG_TYPES } from '../types/TagTypes';
import PROPS from '../types/Props'; // http://wixplorer.wixpress.com/out-of-iframe/guides/Reference/APIs

export function convertPlatformLinksModel(payload) {
  var result = {
    tags: []
  };

  if (payload && Array.isArray(payload)) {
    result.tags = payload.reduce(function (acc, curr) {
      if (curr && curr.rel && curr.href) {
        var _props;

        return acc.concat({
          type: TAG_TYPES.LINK,
          props: (_props = {}, _props[PROPS.REL] = curr.rel, _props[PROPS.HREF] = curr.href, _props)
        });
      }

      return acc;
    }, result.tags);
  }

  return result;
}